import { useRouter } from "next/router"
import { useRef } from "react"
import { t } from "translations"

import { styled } from "@mui/material/styles"

export default function SkipToContent() {
    const router = useRouter()

    const skipLinkRef = useRef<HTMLAnchorElement>(null)

    const handleSkip = (e: React.MouseEvent<HTMLAnchorElement>) => {
        e.preventDefault()

        const el = document.getElementById("layout-container")
        if (el) {
            el.removeAttribute("tab-index")

            el.setAttribute("tab-index", "-1")

            el.scrollIntoView({ block: "start", behavior: "smooth" })

            setTimeout(() => {
                el.focus()
            }, 10)
        }
    }

    return (
        <SkipLink
            ref={skipLinkRef}
            onClick={handleSkip}
            href={`${router.asPath}#layout-container`}>
            {t.skipToContent}
        </SkipLink>
    )
}

const SkipLink = styled("a")(({ theme }) => ({
    background: theme.palette.common.white,
    color: theme.palette.primary.main,
    padding: theme.spacing(1, 2),
    position: "absolute",
    top: -50,
    left: theme.spacing(3),
    zIndex: 9999,
    textDecoration: "none",
    transition: "top 0.3s ease-in-out",

    "&:focus": {
        top: theme.spacing(3)
    }
}))
